// Classes.
import { BaseLocator } from "./base.locator";
import { LevelLocatorComponent } from "./level.locator-component";
import { DateLocatorComponent } from "./date.locator-component";
import { WithResultsLocatorComponent } from "./with-results.locator-component";
import { LiveLocatorComponent } from "./live.locator-component";
import { StringLocatorComponent } from "./string.locator-component";
import { SortingLocatorComponent } from "./sorting.locator-component";
import { DetailedLocatorComponent } from "./detailed.locator-component";
import { DisciplineLocatorComponent } from "./discipline.locator-component";
import { YearLocatorComponent } from "./year.locator-component";
import { CategoryIdLocatorComponent } from "./categoryid.locator-component";
import { CategoryLocatorComponent } from "./category.locator-component";
import { RankSortingLocatorComponent } from "./indoor-sorting-locator";

export class SeriesAmateusRankingsLocator extends BaseLocator {
  public catid: CategoryIdLocatorComponent;
  public category: CategoryLocatorComponent;
  public year: YearLocatorComponent;
  public discipline: DisciplineLocatorComponent;
  public search: StringLocatorComponent;
  public sort: RankSortingLocatorComponent;
  public sortindoor: RankSortingLocatorComponent;
  public detailed: DetailedLocatorComponent;
  constructor() {
    super("seriesAmateursLocator");
    this.addComponentByType("category");
    this.addComponentByType("year");
    this.addComponentByType("discipline");
    this.addComponentByType("search");
    this.addComponentByType("sortindoor");
    this.addComponentByType("detailed");
    this.addComponentByType("search");
  }
}
